//import toolTipIcon from '../imgs/toolTipIcon.svg';
import useStore from '../../store/store';
//import ToolTipIcon from '../ToolTipIcon';
import { Container, Row, Col } from 'react-grid-system'
import { useScreenClass } from 'react-grid-system';

const roundValue = (value) => {
	return +(Math.round(value + "e+1") + "e-1");
}

const getBandText = (value) => {
	let myValue = value.split('b');
	myValue = myValue.toString().replace("sn", "").replace(",", "");
	return myValue;
}

const SoundPowerOctaves = (
	{
		changeBandNoiseValue,
		totalSourceNoiseA,
		receiverNoiseA,
		totalRecieverNoiseA,
		bandSetNoise = { bandSetNoise },
		measuredNoiseNoBarrierSoundPower,
		measuredNoiseNoBarrierSoundPowerTotal,
		barrierAttenuationList,
		receiverNoiseLin,
		receiverSPLList,
		totalSourceNoiseDba
	}
) => {
	const barrierScenario = useStore((state) => state.scenario);
	const screenClass = useScreenClass();

	return (
		<>
			<div className="panel" id="soundPowerOctavesPanel" style={{ display: 'flex', flexFlow: 'column', height: '100%' }}>
				<Container>
					{
						['sm', 'xs'].includes(screenClass) && (
							<>
								<Row>
									<Col xs={12} style={{ display: 'flex', alignItems: 'flex-end', paddingLeft: '0px' }}>
										Sound Power (Linear)
									</Col>
									<Col xs={12} style={{ display: 'inline-flex', marginTop: '10px', paddingLeft: '0px' }}>
										{Object.keys(bandSetNoise).map((item, index) => {
											return (
												index <= 2 && (
													<>
														<label className="panel-number" key={"lbl1a" + index}>
															{getBandText(item)}
															<input key={index} className="inner-panel-boxed-input" defaultValue={bandSetNoise[item]} onChange={(e) => { changeBandNoiseValue(e, item) }}></input>
														</label>
														{
															index === Object.values(bandSetNoise).length - 1 && (
																<label className="panel-number" key={"unique" + index} >
																	dB(A):
																	<div className="output">
																		{roundValue(totalSourceNoiseA)}
																	</div>
																</label>
															)
														}
													</>
												)
											)
										})}
									</Col>
								</Row>
								<Row>
									<Col xs={12} style={{ display: 'inline-flex', marginTop: '10px', paddingLeft: '0px' }}>
										{Object.keys(bandSetNoise).map((item, index) => {
											return (
												index > 2 && index <= 5 && (
													<>
														<label className="panel-number" key={"lbl1a" + index}>
															{getBandText(item)}
															<input key={index} className="inner-panel-boxed-input" defaultValue={bandSetNoise[item]} onChange={(e) => { changeBandNoiseValue(e, item) }}></input>
														</label>
														{
															index === Object.values(bandSetNoise).length - 1 && (
																<label className="panel-number" key={"unique" + index} >
																	dB(A):
																	<div className="output">
																		{roundValue(totalSourceNoiseA)}
																	</div>
																</label>
															)
														}
													</>
												)
											)
										})}
									</Col>
								</Row>
								<Row>
									<Col xs={12} style={{ display: 'inline-flex', marginTop: '10px', paddingLeft: '0px' }}>
										{Object.keys(bandSetNoise).map((item, index) => {
											return (
												index > 5 && (
													<>
														<label className="panel-number" key={"lbl1a" + index}>
															{getBandText(item)}
															<input key={index} className="inner-panel-boxed-input" defaultValue={bandSetNoise[item]} onChange={(e) => { changeBandNoiseValue(e, item) }}></input>
														</label>
														{
															index === Object.values(bandSetNoise).length - 1 && (
																<label className="panel-number" key={"unique" + index} >
																	dB(A):
																	<div className="output">
																		{roundValue(totalSourceNoiseA)}
																	</div>
																</label>
															)
														}
													</>
												)
											)
										})}
									</Col>
								</Row>
							</>
						)
					}


					{
						['md', 'lg', 'xl', 'xxl'].includes(screenClass) && (
							<>
								<Row>
									<Col xs={3} style={{ display: 'flex', alignItems: 'flex-end', paddingLeft: '0px' }}>
										<div style={{ width: '150px' }} >Sound Power</div>
									</Col>
									<Col xs={9} style={{ display: 'inline-flex', marginTop: '10px', paddingLeft: '0px' }}>
										{Object.keys(bandSetNoise).map((item, index) => {
											return (
												<>
													<label className="panel-number" key={"lbl1a" + index}>
														{getBandText(item)}
														<input key={index} className="inner-panel-boxed-input" defaultValue={bandSetNoise[item]} onChange={(e) => { changeBandNoiseValue(e, item) }}></input>
													</label>
													{
														index === Object.values(bandSetNoise).length - 1 && (
															<label className="panel-number" key={"unique" + index} >
																dB(A):
																<div className="output" style={{ marginTop: '10px' }}>
																	{roundValue(totalSourceNoiseDba)}
																</div>
															</label>
														)
													}
												</>
											)
										})}
									</Col>
								</Row>
								
								{/* barrierAttenuationList
								<Row>
									<Col xs={3} style={{ display: 'flex', alignItems: 'flex-end', paddingLeft: '0px' }}>
										<div style={{ width: '150px' }} >Barrier Attenuation</div>
									</Col>
									<Col xs={9} style={{ display: 'inline-flex', marginTop: '10px', paddingLeft: '0px' }}>
										{Object.keys(barrierAttenuationList).map((item, index) => {
											return (
												<>
													<label className="panel-number" key={"lbl1ba" + index}>
														
														<input key={"lbl1baw" +index} className="inner-panel-boxed-input" defaultValue={roundValue(barrierAttenuationList[item])} ></input>
													</label>
												</>
											)
										})}
									</Col>
								</Row> */}
								{/* receiverSPLList per band.
								
								<Row>
									<Col xs={3} style={{ display: 'flex', alignItems: 'flex-end', paddingLeft: '0px' }}>
										<div style={{ width: '150px' }} >Reciever SPL Noise Lin</div>
									</Col>
									<Col xs={9} style={{ display: 'inline-flex', marginTop: '10px', paddingLeft: '0px' }}>
										{Object.keys(receiverSPLList).map((item, index) => {
											return (
												<>
													<label className="panel-number" key={"lbl1bau" + index}>
														
														<input key={"scream" +index} className="inner-panel-boxed-input" defaultValue={roundValue(receiverSPLList[item])} ></input>
													</label>
												</>
											)
										})}
									</Col>
								</Row> */}
							</>
						)
					}
					{/* end first line */}

					{/* start second line */}

					{

						['sm', 'xs'].includes(screenClass) && (
							<>
								<Row>
									<Col xs={12} style={{ display: 'flex', alignItems: 'flex-end', paddingLeft: '0px', marginTop: '20px' }}>
										<div>No Barriers <span className='text-italic'>A weighted</span></div>
									</Col>
									<Col xs={12} style={{ display: 'inline-flex', marginTop: '10px', paddingLeft: '0px' }}>
										{receiverSPLList.map((item, index) => {
											return (
												index <= 2 && (
													<>
														<div className='output'>
															{roundValue(item)}
														</div>
														{
															index === Object.values(receiverSPLList).length - 1 && (
																<div className='output'>
																	{roundValue(measuredNoiseNoBarrierSoundPowerTotal)}
																</div>
															)
														}
													</>
												)
											)
										})}
									</Col>
								</Row>
								<Row>
									<Col xs={12} style={{ display: 'inline-flex', marginTop: '10px', paddingLeft: '0px' }}>
										{receiverSPLList.map((item, index) => {
											return (
												index > 2 && index <= 5 && (
													<>
														<div className='output'>
															{roundValue(item)}
														</div>
														{
															index === Object.values(receiverSPLList).length - 1 && (
																<div className='output'>
																	{roundValue(measuredNoiseNoBarrierSoundPowerTotal)}
																</div>
															)
														}
													</>
												)
											)
										})}
									</Col>
								</Row>
								<Row>
									<Col xs={12} style={{ display: 'inline-flex', marginTop: '10px', paddingLeft: '0px' }}>
										{receiverSPLList.map((item, index) => {
											return (
												index > 5 && (
													<>
														<div className='output'>
															{roundValue(item)}
														</div>
														{
															index === Object.values(receiverSPLList).length - 1 && (
																<div className='output'>
																	{roundValue(measuredNoiseNoBarrierSoundPowerTotal)}
																</div>
															)
														}
													</>
												)
											)
										})}
									</Col>
								</Row>
							</>
						)
					}
					{
						['md', 'lg', 'xl', 'xxl'].includes(screenClass) && (
							<>
								<Row>
									<Col xs={3} style={{ display: 'flex', alignItems: 'flex-end', paddingLeft: '0px' }}>
										<div >No Barriers <span className='text-italic'>A weighted</span></div>
									</Col>
									<Col xs={9} style={{ display: 'inline-flex', paddingLeft: '0px' }}>
										{receiverSPLList.map((item, index) => {
											return (
												<>
													<div className='output'>
														{roundValue(item)}
													</div>
													{
														index === Object.values(receiverSPLList).length - 1 && (
															<div className='output'>
																{roundValue(measuredNoiseNoBarrierSoundPowerTotal)}
															</div>
														)
													}
												</>
											)
										})}
									</Col>
								</Row>
							</>
						)
					}
					{/* end second line */}

					{

						['sm', 'xs'].includes(screenClass) && (
							<>
								<Row>
									<Col xs={12} style={{ display: 'flex', alignItems: 'flex-end', paddingLeft: '0px', marginTop: '20px' }}>
										<div>Barriers <span className='text-italic'>A weighted</span></div>
									</Col>
									<Col xs={12} style={{ display: 'inline-flex', marginTop: '10px', paddingLeft: '0px' }}>
										{receiverNoiseA.map((item, index) => {
											return (
												index <= 2 && (
													<>
														{
															barrierScenario !== 'noBarriers' && (
																<>
																	<div className='output'>
																		{roundValue(item)}
																	</div>
																</>
															)
														}
														{
															barrierScenario === 'noBarriers' && (
																<>
																	<div className='output'>
																		{''}
																	</div>
																</>
															)

														}
													</>
												)
											)
										})}
									</Col>
								</Row>
								<Row>
									<Col xs={12} style={{ display: 'inline-flex', marginTop: '10px', paddingLeft: '0px' }}>
										{receiverNoiseA.map((item, index) => {
											return (
												index > 2 && index <= 5 && (

													<>
														{
															barrierScenario !== 'noBarriers' && (
																<>
																	<div className='output'>
																		{roundValue(item)}
																	</div>
																</>
															)
														}
														{
															barrierScenario === 'noBarriers' && (
																<>
																	<div className='output'>
																		{''}
																	</div>
																</>
															)

														}
													</>
												)
											)
										})}
									</Col>
								</Row>
								<Row>
									<Col xs={12} style={{ display: 'inline-flex', marginTop: '10px', paddingLeft: '0px' }}>
										{receiverNoiseA.map((item, index) => {
											return (
												index > 5 && (

													<>
														{
															barrierScenario !== 'noBarriers' && (
																<>
																	<div className='output'>
																		{roundValue(item)}
																	</div>
																	{
																		index === Object.values(receiverNoiseA).length - 1 && (
																			<div className='output'>
																				{roundValue(totalRecieverNoiseA)}
																			</div>
																		)
																	}
																</>
															)
														}
														{
															barrierScenario === 'noBarriers' && (
																<>
																	<div className='output'>
																		{''}
																	</div>
																	{
																		index === Object.values(receiverNoiseA).length - 1 && (
																			<div className='output'>
																				{''}
																			</div>
																		)
																	}
																</>
															)

														}
													</>
												)
											)
										})}
									</Col>
								</Row>
							</>
						)
					}
					{
						['md', 'lg', 'xl', 'xxl'].includes(screenClass) && (
							<>
								<Row>
									<Col xs={3} style={{ display: 'flex', alignItems: 'flex-end', paddingLeft: '0px' }}>
										<div>Barriers <span className='text-italic'>A weighted</span></div>
									</Col>
									<Col xs={9} style={{ display: 'inline-flex', paddingLeft: '0px' }}>
										{receiverNoiseA.map((item, index) => {
											return (
												<>
													{
														barrierScenario !== 'noBarriers' && (
															<>
																<div className='output'>
																	{roundValue(item)}
																</div>
																{
																	index === Object.values(receiverNoiseA).length - 1 && (
																		<div className='output'>
																			{roundValue(totalRecieverNoiseA)}
																		</div>
																	)
																}
															</>
														)

													}
													{
														barrierScenario === 'noBarriers' && (
															<>
																<div className='output'>
																	{''}
																</div>
																{
																	index === Object.values(receiverNoiseA).length - 1 && (
																		<div className='output'>
																			{''}
																		</div>
																	)
																}
															</>
														)

													}

												</>
											)
										})}
									</Col>
								</Row>
							</>
						)
					}
					{/* end third line */}
				</Container>
			</div>
		</>
	)
}

export default SoundPowerOctaves;